import React, { useState } from 'react';
import {
	Collapse,
	Navbar,
	NavbarToggler,
	NavbarBrand,
	Nav,
	NavItem,
	NavLink,
	NavbarText,
	Input,
	InputGroup,
} from 'reactstrap';
import { useHistory, useLocation } from 'react-router-dom';
import { useSearch, usePage } from "../hooks";
import HomeIcon from '@material-ui/icons/Home';
import RefreshIcon from '@material-ui/icons/Refresh';
import Tooltip from '@material-ui/core/Tooltip';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import { useFavoriteOpen, useFavorite, useLanguage } from '../hooks';
import { withStyles } from '@material-ui/core/styles';
import Badge from '@material-ui/core/Badge';
import Translate from "../components/Translate";
import clsx from 'clsx';
import Chip from '@material-ui/core/Chip';
import { setLanguage } from '../utils/storage';

const StyledBadge = withStyles((theme) => ({
	badge: {
		right: -3,
		top: 3,
	},
}))(Badge);

const AppNavbar = () => {
	const [, setSearchString] = useSearch();
	const [, setPage] = usePage();
	const [, setFavoriteOpen] = useFavoriteOpen();
	const [favorites] = useFavorite();
	const [userLanguage, setUserLanguage] = useLanguage();

	const favoriteCount = favorites.length;
	const favoriteIcon = favoriteCount > 0 ? <FavoriteIcon /> : <FavoriteBorderIcon />;

	const favoriteClass = clsx('navbar', { cursor: favoriteCount });

	const history = useHistory();
	const location = useLocation();

	const routeChange = path => {
		history.push(path);
	};

	const [isOpen, setIsOpen] = useState(false);

	const handleSearch = (e) => {
		setSearchString(e.target.value.toLowerCase());
	};

	const handleFocus = () => {
		setPage(1);
		if (location.pathname === '/product') routeChange('/');
		document.getElementById("search").focus();
	};

	const handleLanguage = () => {
		if (userLanguage === 'traditional') {
			setUserLanguage('simplified');
			setLanguage('simplified');
		} else {
			setUserLanguage('traditional');
			setLanguage('traditional');
		}
	};

	const languageChange = userLanguage === 'traditional' ? '改用简体' : '改用繁體';

	const toggle = () => setIsOpen(!isOpen);

	const commonActions = () => {
		setPage(1);
		setSearchString('');
		document.getElementById("search").value = '';
	}

	const goHome = () => {
		commonActions();
		routeChange('/');
	}

	const goAmazon = () => {
		commonActions();
		routeChange('/amazon');
	}

	const goSave = () => {
		commonActions();
		routeChange('/save');
	}

	const goSns = () => {
		commonActions();
		routeChange('/sns');
	}

	const goWalmart = () => {
		commonActions();
		routeChange('/walmart');
	}

	return (
		<React.Fragment>
			<Navbar expand="md" dark style={{ zIndex: '999' }}>
				<Nav style={{ flexWrap: 'nowrap' }}>
					{/* <NavItem>
						<Tooltip title={Translate("重新整理")} arrow>
							<NavLink className="cursor navbar navIcon" href="/">
								<RefreshIcon />
							</NavLink>
						</Tooltip>
					</NavItem> */}
					<NavItem>
						<Tooltip title={Translate("首頁")} arrow>
							<NavLink className="cursor navbar navIcon" href="/">
								<HomeIcon />
							</NavLink>
						</Tooltip>
					</NavItem>
				</Nav>
				<NavbarText style={{ marginLeft: '0.5rem', marginRight: '0.5rem' }}>
					<InputGroup>
						<Input
							type="text"
							placeholder={Translate("搜尋")}
							id="search"
							onChange={e => handleSearch(e)}
							onFocus={handleFocus}
						/>
					</InputGroup>
				</NavbarText>
				<NavbarToggler onClick={toggle} />
				<Collapse isOpen={isOpen} navbar>
					<Nav className="mr-auto" navbar>
						<NavItem>
							<NavLink onClick={goSave} className="cursor navbar" style={{ textDecoration: "none", whiteSpace: 'noWrap' }}>
								{Translate("省錢秘笈")}
							</NavLink>
						</NavItem>
						<NavItem>
							<NavLink onClick={goAmazon} className="cursor navbar">
								Amazon
							</NavLink>
						</NavItem>
						<NavItem>
							<NavLink onClick={goSns} className="cursor navbar" style={{ textDecoration: "none", whiteSpace: 'noWrap' }}>
								{Translate("S&S")}
							</NavLink>
						</NavItem>
						<NavItem>
							<NavLink onClick={goWalmart} className="cursor navbar" style={{ textDecoration: "none", whiteSpace: 'noWrap' }}>
								{Translate("Walmart")}
							</NavLink>
						</NavItem>
						<NavItem>
							<a className="cursor navbar" href="https://my.hoconinfo.com/" target="_blank" rel="noreferrer" style={{ textDecoration: "none", whiteSpace: 'noWrap' }}>
								{Translate("折扣碼")}
							</a>
						</NavItem>
						<NavItem>
							<Tooltip title={Translate("我的收藏")} arrow>
								<NavLink onClick={() => favoriteCount && setFavoriteOpen(true)} className={favoriteClass}>
									<StyledBadge badgeContent={favoriteCount || '0'} color="secondary">
										{favoriteIcon}
									</StyledBadge>
								</NavLink>
							</Tooltip>
						</NavItem>
					</Nav>
					<NavbarBrand>
						<Chip label={languageChange} color="primary" onClick={handleLanguage} />
					</NavbarBrand>
					<NavbarBrand onClick={goHome} className="cursor navbar">
						{Translate("Hoconinfo 美國好康折扣快報")}
					</NavbarBrand>
				</Collapse>
			</Navbar>
		</React.Fragment >
	);
};

export default AppNavbar;
